import { IonIcon } from '@ionic/react';
import { globeOutline } from 'ionicons/icons';
import React from 'react';

import { UiButtonBase } from '@/components/ui/ButtonBase';
import { UiTypography } from '@/components/ui/Typography';
import { useAccount } from '@/hooks/useAccount';
import { apiV1GetMeAuthRequest } from '@/modules/api';
import { webCampaign } from '@/modules/webCampaign';
import { removeAllDataAndStartOver } from '@/utils/removeAllDataAndStartOver';

import { StoreLinks } from '../StoreLinks';

import { ContentStyles, WebVersionLinkStyles } from './Content.styles';

export const Content = () => {
  const { user } = useAccount();

  const [authToken, setAuthToken] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchAuthToken = async () => {
      const auth = await apiV1GetMeAuthRequest();
      setAuthToken(auth.token);
    };
    fetchAuthToken();
  }, []);

  return (
    <ContentStyles className="content">
      <div className="next-actions">
        <StoreLinks />

        {webCampaign.setup.hasWebAppLink && !!authToken && (
          <WebVersionLinkStyles>
            <a href={webCampaign.getAuthUrl(authToken)} target="_blank">
              <IonIcon icon={globeOutline} />
              <UiTypography variant="label-large" color="white">
                Web version
              </UiTypography>
            </a>
          </WebVersionLinkStyles>
        )}

        <UiTypography variant="body-large" align="center">
          OR via the link we sent to {user?.email} (check Inbox and Spam).
        </UiTypography>
      </div>

      <UiButtonBase
        onClick={removeAllDataAndStartOver}
        expand="full"
        className="btn-remove-all-data"
      >
        Remove all data and start over
      </UiButtonBase>
    </ContentStyles>
  );
};
